import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/Ariel/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager" */ "/var/www/html/Ariel/node_modules/next/dist/client/image-component.js");
